/**
 * utility file to hold sleep or timout generic methods
 */

export const sleep = (delay = 0) => new Promise(resolve => setTimeout(resolve, delay))
